/** Generated by @jobilla/openapi-codegen. Do not edit manually. */

import { z } from 'zod/v4'

export const jobDataSchema = z.object({
	id: z.string(),
	remoteId: z.string().nullable(),
	name: z.string().nullable(),
	jobCode: z.string().nullable(),
	description: z.string().nullable(),
	confidential: z.boolean().nullable(),
	weeklyHours: z.number().nullable(),
	employmentType: z.string().nullable(),
	status: z.string().nullable(),
	visibility: z.string().nullable(),
	category: z.string().nullable(),
	department: z.string().nullable(),
	postUrl: z.string().nullable(),
	experienceLevel: z.string().nullable(),
	remoteWorkStatus: z.string().nullable(),
	salaryAmount: z.number().nullable(),
	salaryAmountFrom: z.number().nullable(),
	salaryAmountTo: z.number().nullable(),
	salaryCurrency: z.string().nullable(),
	salaryPeriod: z.string().nullable(),
	location: z.object({
		city: z.string().nullable(),
		country: z.string().nullable(),
		state: z.string().nullable(),
		street1: z.string().nullable(),
		street2: z.string().nullable(),
		zipCode: z.string().nullable(),
		raw: z.string().nullable(),
	}).nullable(),
	customFields: z.array(z.string()).nullable().default([]),
	integrationFields: z.array(z.string()).default([]),
	openedAt: z.string().nullable(),
	closedAt: z.string().nullable(),
	remoteCreatedAt: z.string().nullable(),
	remoteUpdatedAt: z.string().nullable(),
	contactId: z.string().nullable(),
	changedAt: z.string().nullable(),
	remoteDeletedAt: z.string().nullable(),
	stages: z.array(z.string()).nullable(),
	screeningQuestions: z.array(z.string()).nullable(),
	jobPostings: z.array(z.string()).nullable(),
	hiringTeam: z.array(z.string()).nullable(),
	updatedAt: z.iso.datetime().nullable(),
	hasCampaign: z.boolean().default(false),
	missingDetails: z.array(z.union([z.literal('title'), z.literal('location'), z.literal('description')])).default([]),
	openCampaignId: z.string().nullable(),
})

export type JobDataSchema = z.infer<typeof jobDataSchema>
